import 'twin.macro';

const CounterAfterFeedBackFinish = ({ counter }) => {
  return <p tw="text-[400px] text-white [font-family: Roboto, sans-serif]">{counter}</p>;
};

export default CounterAfterFeedBackFinish;
